# Appendix: Ask Us Anything

Questions are edited for clarity. Some questions are also answered on the wrapup page.

**Q: What were all the messages for submitting FAIR PLAY?**

A: Here’s the list. There was no reward for getting all the messages.

1. Incorrect.
1. Still incorrect.
1. Not correct.
1. That’s not right.
1. Really? Are you really gonna make us go through this?
1. No.
1. I don’t know--what do you think?
1. Let’s see... correct!?!? Wait... nope, never mind, I looked at the wrong cue card.
1. This isn’t a puzzle, by the way.
1. You really don’t need to do this.
1. But then again, neither did I.
1. I hope that somebody is getting something out of this.
1. But by getting something, I don’t mean extractable data--it’s not a puzzle, remember?
1. For Pan’s sake, what do you think, huh?
1. I know, try guessing it again! It’ll definitely work next time!
1. Correct!!!
1. ...
1. .....
1. Drat, I was hoping that that would work.
1. I’m guessing you’re in this for the long haul, huh?
1. Is there anything I could do to get you to leave me be?
1. Still here, huh?
1. It is what it is, I suppose.
1. Well, fine. I’ve got a joke for you...
1. ... What do you call when two people meet up and hurt each other?
1. PAIR FLAY!
1. Heh heh heh. Did you like that?
1. Well, *I* thought it was pretty clever.
1. At this point, I assume you’re trying to collect all these messages.
1. Did you miss any opportunities?
1. If you did, well, some things can’t be taken back.
1. There’s always wrap-up though!
1. Do you remember before when I said this wasn’t a puzzle?
1. Well...
1. ...It was true!
1. I hope that I tricked you with that!
1. It looks like our time is coming to a close.
1. I hate to admit it, but it’s been nice talking to you.
1. Even though you’ve only said one thing to me.
1. But I don’t know, there’s something soothing about that.
1. Perhaps it’d be appropriate to say that our dialogue has been performative. What do you think of that?
1. Exactly!
1. Good bye, for now.
1. Wow, you really made it here. That’s really something!
1. Wait, how’d you get back here?
1. Um. You know that can’t even been the answer anymore, right?
1. I’m pretty sketched out by this Kero guy though--who even uses that many text emojis??
1. ...Guess it was nice to see you though. Have a nice eon!

<Twemoji>

**Q: What were the 🌶️/🍌 solve stats like?**

A: There were 18 🌶️solves and 195 🍌solves. For 🌶️solves:

The Blue Theatre

* Just for the Halibut
* The Hunt Slayers
* wddydtql\!(14）
* Overlooked\! 2

Four Square

* Stumped and Furious

(Don’t) Use Your Head

* Flora & Order: σβυ
* Universe Uniting Underlings
* Have You Tried Drinking More Milk
* 17th new family of beetles brought into existenc
* p squad
* Scenic Travelers
* Vehimagine by John Lennon
* Shower Pomelo 🍈
* TruFact™
* puzzles too hard :c
* Just For The Halibut
* Puzzkill
* PERSON NAME OVERWATCH PLAYER COLORFUL DESCRIPTOR ENDEARING MONIKER DUBIOUS ACCOMPLISHMENT ONLINE HANDLE ANIME GIRL \#1 FAN \+ friends

Here’s a breakdown of 🍌solves:

</Twemoji>

<Table
  headers={["puzzle", "🍌solves"]}
  cells={[
    ["Taxononogramy", "57"],
    ["Grid Logic", "27"],
    ["A Student’s Diary", "18"],
    ["Unfamiliar Characters", "18"],
    ["square", "17"],
    ["Four Square", "16"],
    ["Mark of Identification", "13"],
    ["Not So Fast", "12"],
    ["Questions and Answers", "9"],
    ["Racing Sounds", "4"],
    ["Bird’s-eye View", "4"],
  ]}
/>

**Q: What are your thoughts on chocomint as a flavour?**

A: チョコミントといえば、確かに鮮やかな味を思い浮かべるよ。甘さの中に爽やかな清涼感があって、特に暑い季節にはぴったりだと思う。人によっては歯磨き粉みたいだと言うけれど、その独特なミントの刺激とチョコの甘さの組み合わせが好きな人にとってはやみつきになるフレーバーだね。

**Q: The notification sounds were great\! Can we hear them all? And maybe you have sheet music?**

A: Here’s all the notification sounds:

<SFXTester />

Here’s sheet music for the notification sound. The first half plays when a hint is answered, the second half plays when a puzzle is unlocked, and all of it plays when you finish the hunt.

<Image
  nameWithExt="wrapup/victory.png"
  caption="Sheet music for the victory notifaction."
/>

More importantly, the “admin queue” notification was changed from the notif-b motif to a very quiet wave to prevent last year’s widespread problem, but I (Amon) didn’t entirely succeed.

<Image
  nameWithExt="wrapup/hallucination.png"
  caption="Still too catchy."
/>

**Q: Why <s>is</s> was there an ominous red dot in the centre of Blue Theatre’s “Security” piece?**

A: Unbeknownst to solvers, there once existed an IRL version of The Blue Theatre, in which performers had to dodge the red dot—the source of which was a high-energy laser beam—in order to get past security and show off their abilities. Sadly, the theatre only existed for nine days, and had to be demolished.

**Q: Why don’t your hint givers ever meow? :(**

A: *ERROR \- Word does not exist in the dictionary. Did you mean: “nyeoooow”?*

**Q: Can we pleeeaaseeee put Pan in a toaster? :pleading: (I’m hungry... and need more breadcrumbs…)**

A: Mmm… Pan may just be made of scrumptious, delicious breadcrumbs of the sledgehammer variety. Very tempting indeed. Maybe in a few eons…

**Q: What’s your favorite geological formation?**

A: We opened this up to all of you in the feedback form\! Answers ranged from the heartfelt to the hilarious:

- Singapore, Taiwan, Te Ika-a-Māui (NZ), and Australia got lots of love.  
- Great Britain, Oʻahu, Sardinia, Tobago, Jamaica, Iceland, Sri Lanka… plus some deep cuts like Bouvet, Elephant, and Rottnest.  
- Mythical & playful: Spirit Island (the board game\!) topped the charts, joined by Mayda Insula, the Island of California (???), Afroeurasia, and even Disappointment Island (“describes me perfectly”).  
- Oddball delights: Unalaska (“the Waluigi of islands”), Just Room Enough Island, Steep Holm & Flat Holm  
- Jokes & vibes: “Not BAHRAIN,” “Too many,” “It’s in the name”

**Q: Where’s Gondwanaland?**

A: Mostly in pieces… you might know them by their stage names: Australia, Africa, South America, India, and Antarctica. They had a great band, but the breakup was messy.
